<!-- エラー画面 -->
<template>
  <div id="wrapper1">
    <img :src="logoImage" :alt="altText" class="with-kaunet_logo-overtime" />

    <h2 class="com_mgb20 com_mgt100 com_fs26 com_medium1 com_center1">
      予期しないエラーが発生しました。
    </h2>

    <p class="com_mgb50 com_reguler1 com_center1">
      大変恐れ入りますが再度同じ手順を行って頂き、それでも正しく動作しない場合は<br />
      担当営業もしくはカウネットにお問い合わせください
    </p>

    <p class="com_copyright1 com_mgt100">© 2025 Kaunet</p>
  </div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "AboutComponent",
  setup() {
    // --- システム区分に応じてログイン画像を切替（ビルド時に展開される） ---
    const STYLE_MAP: Record<string, string> = {
      "01": require("@/assets/common/img/01/with-kaunet_logo-errorpage.png"),
      "02": require("@/assets/common/img/02/with-kaunet_logo-errorpage.png"),
      "03": require("@/assets/common/img/03/with-kaunet_logo-errorpage.png"),
    };

    const STYLE_ALT_MAP: Record<string, string> = {
      "01": "ウィズカウネット エージェントポータル",
      "02": "ベースカウネット エージェントポータル",
      "03": "サプライヤーポータル",
    };

    const systemKbn = process.env.VUE_APP_SYSTEM_KBN;
    const logoImage = STYLE_MAP[systemKbn];
    const altText = STYLE_ALT_MAP[systemKbn];

    return {
      logoImage,
      altText,
    };
  },
});
</script>
